(function() {
  var _history = window.history;
  var _location = window.location;

  // IE9 pushState fallback
  if (!_history.pushState) {
    _history.pushState = _history.replaceState = function(state, title, url) {
          if (url !== _location.pathname) {
              _location.pathname = url;
          }
      };
  }
}());



//////////////////
// WEBPACK FOOTER
// ./src/vendors/polyfills/pushstate-ie9.js
// module id = 1353
// module chunks = 23